(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-overview-parts/assets/javascripts/footers/coupon-footer-system-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-overview-parts/assets/javascripts/footers/coupon-footer-system-rows.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectSystemSize = _svs$components$tipse.selectSystemSize,
  selectReduceCount = _svs$components$tipse.selectReduceCount,
  selectNumberOfCompletedBoards = _svs$components$tipse.selectNumberOfCompletedBoards;
const CouponFooterRowsView = svs.components.tipsen.couponOverviewParts.CouponFooterRowsView;
const CouponFooterSystemRows = _ref => {
  let _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? true : _ref$isValid,
    _ref$isReduced = _ref.isReduced,
    isReduced = _ref$isReduced === void 0 ? true : _ref$isReduced,
    price = _ref.price,
    system = _ref.system;
  const couponId = useCouponId();
  const completedBoards = useSelector(state => selectNumberOfCompletedBoards(state, couponId));
  const selectedSystemSize = useSelector(state => selectSystemSize(state, couponId, 0));
  const reducedCount = useSelector(state => selectReduceCount(state, couponId));
  const numRows = isReduced ? reducedCount : completedBoards;
  const systemSize = isReduced ? selectedSystemSize : 0;
  const _price = isValid ? price : 0;
  return React.createElement(CouponFooterRowsView, {
    hasRowLabel: !isReduced,
    maxRows: systemSize,
    numRows: numRows,
    price: _price,
    systemLabel: system
  });
};
setGlobal('svs.components.tipsen.couponOverviewParts.CouponFooterSystemRows', CouponFooterSystemRows);

 })(window);